import { Badge } from "@/components/ui/badge";
import { STATUS_META } from "@/lib/constants";

export const StatusBadge = ({ status, pulse = false }) => {
  const meta = STATUS_META[status] || { label: status, color: "#94A3B8", bg: "rgba(148,163,184,0.12)" };
  const pulseClass = pulse && status === "replied" ? "pulse-emerald" : pulse && status === "searching" ? "pulse-amber" : "";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${pulseClass}`}
      style={{ color: meta.color, backgroundColor: meta.bg, border: `1px solid ${meta.color}33` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: meta.color }} />
      {meta.label}
    </span>
  );
};
